







































































import { Component, Prop, Watch } from "vue-property-decorator";
import LifeCycle from "../decorator/LifeCycle";
import { StoreUseData } from "@/@types/store";
import GameObjectManager from "@/app/basic/GameObjectManager";
import { Direction, MediaInfo } from "@/@types/room";
import { Mixins } from "vue-mixin-decorator";
import ComponentVue from "@/app/core/window/ComponentVue";
import DirectionTypeSelect from "@/app/basic/common/components/select/DirectionTypeSelect.vue";
import ImageTagSelect from "@/app/basic/common/components/select/ImageTagSelect.vue";
import CtrlButton from "@/app/core/component/CtrlButton.vue";
import { getSrc } from "@/app/core/utility/Utility";
import VueEvent from "@/app/core/decorator/VueEvent";

@Component({
  components: {
    CtrlButton,
    ImageTagSelect,
    DirectionTypeSelect
  }
})
export default class ImagePickerComponent extends Mixins<ComponentVue>(
  ComponentVue
) {
  @Prop({ type: String, required: true })
  private windowKey!: string;

  @Prop({ type: String, default: null })
  private value!: string | null;

  @Prop({ type: String, default: null })
  private imageTag!: string | null;

  @Prop({ type: Boolean, default: false })
  private isSimple!: boolean;

  @Prop({ type: Boolean, default: false })
  private viewName!: boolean;

  @Prop({ type: String, default: "4em" })
  private imageSize!: string;

  private isMounted: boolean = false;
  private selectImageTag: string | null = null;
  private direction: Direction = "none";

  private rawImageList: StoreUseData<MediaInfo>[] = [];
  private useImageList: StoreUseData<MediaInfo>[] = [];
  private searchText: string = "";

  @VueEvent
  private getSrc(data: string) {
    return getSrc(data);
  }

  @Watch("isMounted")
  @Watch("selectImageTag")
  @Watch("searchText")
  @Watch("rawImageList", { deep: true })
  private async onChangeImageList() {
    if (!this.isMounted) return;
    const regExp = this.searchText ? new RegExp(this.searchText) : null;
    this.useImageList = this.rawImageList.filter(d => {
      if (!d || !d.data) return false;
      if (regExp && !d.data.name.match(regExp)) return false;
      return d.data.tag === this.selectImageTag;
    });
  }

  @VueEvent
  private get selectedTagIndexText() {
    const index = this.useImageList.findIndex(
      image => image.id === this.localValue
    );
    return `${index + 1}/${this.useImageList.length}`;
  }

  @LifeCycle
  private mounted() {
    this.rawImageList = GameObjectManager.instance.mediaList.filter(
      media => media.data!.type === "image"
    );
    this.isMounted = true;
  }

  private get localValue(): string | null {
    return this.value;
  }

  private set localValue(colorStr: string | null) {
    this.input(colorStr);
  }

  public input(colorStr: string | null) {
    this.$emit("input", colorStr);
  }

  @Watch("imageTag", { immediate: true })
  private onChangeImageTag(value: string) {
    this.selectImageTag = value;
  }

  @Watch("selectImageTag")
  private onChangeSelectImageTag() {
    this.$emit("update:imageTag", this.selectImageTag);
  }

  @Watch("direction")
  private onChangeReverse() {
    this.$emit("update:direction", this.direction);
  }

  private get elm(): HTMLDivElement {
    return this.$refs.elm as HTMLDivElement;
  }

  public focus() {
    this.elm.focus();
  }
}
